import { ValueFormatterParams } from 'ag-grid-community'

export const numberFormatter = (params: ValueFormatterParams): string => {
  if (params.value == null || params.value === '') return ''
  return params.value.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
}

export const currencyFormatter = (params: ValueFormatterParams): string => {
  if (params.value == null || params.value === '') return ''
  return params.value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export const percentageFormatter = (params: ValueFormatterParams): string => {
  if (params.value == null || params.value === '') return ''
  return params.value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
